import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { api } from "../../services/api";
import FullLoading from "../Utils/FullLoading";
import { sha256 } from "js-sha256";

/**
 * Resolves a short link to its full order-status URL.
 *
 * The stored long_url carries the customer's phone in clear text, so the phone
 * is replaced with its SHA-256 hash before the browser navigates - the backend
 * lookup accepts either form.
 */
const Redirect = () => {
  const { id } = useParams();

  useEffect(() => {
    if (!id) return;

    api
      .get(`system/url-shortener/${encodeURIComponent(id)}/`)
      .then((response) => {
        const longUrl = response.data?.long_url;
        if (response.status !== 200 || !longUrl) {
          throw new Error("Short link did not resolve to a URL");
        }

        const parsed = new URL(longUrl);
        const params = new URLSearchParams(decodeURIComponent(parsed.search));

        // A '+' in the stored URL decodes to a space; restore it before hashing
        // so the hash matches the phone as the backend stores it.
        const phone = params.get("phone");
        if (phone) {
          parsed.searchParams.set("phone", sha256(phone.replaceAll(" ", "+")));
        }

        window.location.href = parsed.toString();
      })
      .catch((error) => {
        console.error("Failed to resolve short link:", error);
      });
  }, [id]);

  return <FullLoading />;
};

export default Redirect;
